export const AGENT_NAME = "Ask Tiger";
